// import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { ListaPage } from '../pages/lista/lista';
import { FilterPage } from '../pages/filter/filter';
import { BestPage } from '../pages/best/best';

declare var cordova: any;
declare var window: any;

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = ListaPage;

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen
  ) {
    platform.ready().then(() => {

      statusBar.styleDefault();
      splashScreen.hide();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts